import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

const DEFAULT_TITLE = 'Info-Car';

@Injectable({ providedIn: 'root' })
export class AppTitleStrategy extends TitleStrategy {
  constructor(
    private readonly title: Title,
    private readonly translateService: TranslateService
  ) {
    super();
  }

  override updateTitle(routerState: RouterStateSnapshot): void {
    const titleKey = this.buildTitle(routerState);
    const pageTitle = titleKey ? this.translateService.instant(titleKey) : undefined;
    const resolvedTitle = pageTitle && pageTitle !== titleKey ? pageTitle : undefined;
    this.title.setTitle(resolvedTitle ? `${resolvedTitle} – ${DEFAULT_TITLE}` : DEFAULT_TITLE);
  }
}
